import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import KeyFinder from "@/pages/KeyFinder";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Success from "@/pages/Success";
import AppStorePreview from "@/pages/AppStorePreview";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL race-condition fix: if URL fragment has session_id, process it
  // synchronously before any other route renders.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<AuthCallback />} />
      <Route path="/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
      <Route path="/appstore" element={<AppStorePreview />} />
      <Route path="/" element={<ProtectedRoute><KeyFinder /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-ambient bg-grain">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
